type PageMastheadProps = {
  eyebrow: string;
  title: string;
  subtitle?: string;
};

/**
 * Lightweight bespoke page header for secondary screens (Invoices, Accounting,
 * Profile): a gold kicker, a Spectral serif title, an optional subtitle,
 * anchored by a gold hairline rule. The heavier charcoal hero is reserved for
 * the flagship Dashboard / Messaging screens, so the rest of the app stays
 * on-brand without charcoal fatigue.
 */
export function PageMasthead({ eyebrow, title, subtitle }: PageMastheadProps) {
  return (
    <header className="dag-pagehead">
      <p className="dag-pagehead__eyebrow">{eyebrow}</p>
      <h1 className="dag-pagehead__title">{title}</h1>
      {subtitle && <p className="dag-pagehead__sub">{subtitle}</p>}
    </header>
  );
}
